<template>
  <div class="insideBody">
    <div class="studyReport">

      <div
        class="main"
        id="capture"
      >

        <div class="conTop on clr">
          <div
            class="export fr"
            @click="getImg"
          >导出学习报告</div>
        </div>

        <div class="data_top">
          <ul>
								<li class="li1">
									<div class="tit">学习时长</div>
									<div class="text"><span>{{getreportObj.xxsc}}</span>分钟</div>
								</li>
								<li class="li2">
									<div class="tit">学习章节数量</div>
									<div class="text"><span>{{getreportObj.yxxzj}}</span>个</div>
								</li>
								<li class="li3">
									<div class="tit">完整学习数量</div>
									<div class="text"><span>{{getreportObj.wzxx}}</span>个</div>
								</li>
								<li class="li4">
									<div class="tit">获得积分</div>
									<div class="text"><span>{{getreportObj.jf}}</span>积分</div>
								</li>
							</ul>
        </div>

        <div class="data_list">
							<div class="tits">
								学习时间柱状图
								<div class="name_list name_list1 fr">学习时长</div>
							 
							</div>
							<div id="Chart" class="Chart"></div>
				</div>

        <div class="details">
							<div class="data_list">
								<div class="tits">
									智能阅读学习详情
								</div>
								<div class="table">
									<el-table
										:data="tableData"
										style="width: 100%">
										<el-table-column
											align="center"
											prop="studytime"
											min-width="80"
											label="日期">
										</el-table-column>
										<el-table-column
											align="center"
											prop="type"
											min-width="80"
											label="板块">
											<template slot-scope="scope">
												{{scope.row.type | typeName}}
											</template>
										</el-table-column>
										<el-table-column
											align="center"
											prop="name"
											min-width="120"
											label="学习项目">
											<template slot-scope="scope">
												{{scope.row.name+'>练习'+scope.row.gno}}
											</template>
										</el-table-column>
										<el-table-column
											align="center"
											prop="usetime"
											min-width="80"
											label="学习时长">
											<template slot-scope="scope">
												{{scope.row.usetime | usetime}}
											</template>
										</el-table-column>
										<el-table-column
											align="center"
											prop="score1"
											min-width="200"
											label="正确率">
											<template slot-scope="scope" v-if="scope.row.type != 3">
												{{scope.row.score1+' 正确率'+scope.row.score+'%'}}
												<span class="btn" @click="seeUrl(scope.row)">查看</span>
											</template>>
										</el-table-column>
										<el-table-column
											align="center"
											prop="jifen"
											min-width="80"
											label="积分">
											<template slot-scope="scope">
												<span class="red">{{scope.row.jifen}}</span>
											</template>>
										</el-table-column>
									</el-table>
								</div>
								 
							</div>
						</div>
    </div>
    </div>
    
  </div>
</template>
<script>
import domtoimage from "dom-to-image";
import { getyuedustudylist, getYueduReport } from "../../api/report";

export default {
  data() {
    return {
      height: null,
			popupheight: null,
			childheight: null,
			tableData: [],
			checkwrongBlon: false,
			getreportObj: null,
			countpage: 1,
      total: null,
    };
  },
  filters: {
		minNumber(num){
			return Math.floor(num / 60)
		},
		typeName(type){
			if(type == 1){
				return '阅读训练';
			}else if(type == 2){
				return '选句填空';
			}else if(type == 3){
				return '全文研读';
			}
		},
		usetime(num){
			return (Math.floor(num / 60)<10?'0'+Math.floor(num / 60):Math.floor(num / 60))+':'+(Math.floor(num % 60)<10?'0'+Math.floor(num % 60):Math.floor(num % 60))
		}
	},
  created() {
    var that = this;
		that.getreport();
		that.getstudylist();
  },
  methods: {
    getImg() {
      let node = document.getElementById("capture");
      domtoimage.bgcolor = "#ffffff";

      domtoimage
        .toPng(node)
        .then((dataUrl) => {
          let userinfo = this.utils.storageGet("userinfo");

          let link = document.createElement("a");
          link.href = dataUrl; //下载链接
          link.setAttribute("download", `${userinfo.username} - 智能阅读.png`);
          link.style.display = "none"; //a标签隐藏
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
        });
    },
    seeUrl(item){
			var that = this;
			if(item.type == 1){
				that.$router.push({path:'/read?id='+item.gid+'&mno='+item.nianji+'&twoname='+item.name+'&threename='+item.gno+'&answerid='+item.id});
			}else if(item.type == 2){
				that.$router.push({path:'/blanks?id='+item.gid+'&mno='+item.nianji+'&twoname='+item.name+'&threename='+item.gno+'&answerid='+item.id});
			};
			//console.log(item.type);
    },
    getreport(){
			var that = this;
			getYueduReport({
				userid: that.utils.storageGet("userinfo").userid,
			}).then(res => {
        that.getreportObj = res;
        that.Chart();
			});
		},
		getstudylist(){
			var that = this;
			getyuedustudylist({
				userid: that.utils.storageGet("userinfo").userid,
				page: that.countpage,
				size: 1000000
			}).then(res => {
				that.total = res.count;
				that.tableData = res.list;
			});
		},
		Chart(){
			var that = this,myChart = that.$echarts.init(document.getElementById('Chart'));
			myChart.clear();
			// 绘制图表
			if(that.getreportObj){
				myChart.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow'// 默认为直线，可选为：'line' | 'shadow'
						}
					},
					legend: { 
						left:'right',
						top: 0,
						data:[]//['学习时长','有效时长']
					},
					grid: {
						left: 10,
						right: 40,
						bottom: 0,
						containLabel: true
					},
					xAxis: [
						{
							type: 'category',
							name: '日期',
							data: that.getreportObj.echart.riqis
						}
					],
					yAxis: [
						{
							type: 'value',
							name: '时间/分钟',
						}
					],
					series: [
						{
							name:'学习时长',
							type:'bar',
							stack: '日期',
							color: "#4069fa",
							data: that.getreportObj.echart.usetimes
						},
					]
				});
			};
		}
  },
  mounted() {
    var that = this;
    that.height = window.innerHeight - 450 * that.utils.per();
  },
};
</script>
<style scoped>
</style>